import { Auth } from './../Auth';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { AutenticationEventType } from '../autentication.event.type';
import { TweenMax, Quint, Linear, Sine } from 'gsap';
import { AppConfig } from '../../AppConfig';
import * as moment from 'moment';
import { ThemeService } from '../../shared/theme-service/theme.service';

@Component({
	selector: 'app-pass-monitor',
	templateUrl: './pass-monitor.component.html',
	styleUrls: ['./pass-monitor.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PassMonitorComponent implements OnInit, OnDestroy {

	active = false;
	activeAdvice = '';
	blocked = false;
	willBlocked = true;
	unblocked = false;
	timerText = '';
	percentTimer = 0;

	constructor() {
		AppEventDispatcher.listen(AutenticationEventType.LOGIN.PASS_MONITOR, (data) => {
			this.willBlocked = true;
			this.blocked = false;
			this.activeAdvice = '.will-blocked';
			this.show(data);
		});

		AppEventDispatcher.listen(AutenticationEventType.LOGIN.PASS_MONITOR_BLOCKED, (data) => {
			this.willBlocked = false;
			this.blocked = true;
			this.activeAdvice = '.blocked';
			this.show(data);
		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.PASS_MONITOR);
		AppEventDispatcher.removeListener(AutenticationEventType.LOGIN.PASS_MONITOR_BLOCKED);
	}

	tryAgain(blocked: boolean = false) {
		TweenMax.to('[data-component="pass-monitor"] ' + (blocked ? '.blocked' : '.will-blocked'), .8, { left: '320%', ease: Quint.easeOut});
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.USER_AND_PASS, {delay: .2, direction: 'LEFT_TO_RIGHT'});
		
	}

	close() {
		this.hide();
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.USER_AND_PASS, {delay: .2, direction: 'LEFT_TO_RIGHT'});
	}

	startTimer() {
		this.percentTimer = moment(Auth.getInstance().getBlockLoginTime()).diff(moment().utc(true), 'seconds');

		let timer = this.percentTimer;

		let minutes: any;
		let seconds: any;

		const timerInterval = setInterval(() => {

			const minVal: string = String(timer / 60);
			const secVal: string = String(timer % 60);

			minutes = parseInt(minVal, 10);
			seconds = parseInt(secVal, 10);

			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;

			this.timerText = minutes + ':' + seconds;

			if (--timer < 0) {
				timer = 0;

				clearInterval(timerInterval);
				this.timeOver();

			}
		}, 1000);

		TweenMax.to('[data-component="pass-monitor"] .timer .layer', this.percentTimer, {width: '100%', ease: Linear.easeNone});

	}

	timeOver() {
		// TweenMax.to('[data-component="pass-monitor"]', .8, {left: '320%', ease: Quint.easeOut, onComplete: () => {
			this.blocked = false;
			this.active = false;
			Auth.getInstance().unblockLogin();
			window.location.reload(true);
		// }});
	}

	show(data) {
		this.active = true;
		AppEventDispatcher.dispatch(AutenticationEventType.LOGIN.BLOCK_LOADER, { show: false });

		const timerInterval = setInterval(() => {

			if ($('[data-component="pass-monitor"] ' + this.activeAdvice).length > 0) {

				clearInterval(timerInterval);

				if (this.blocked) {
					this.startTimer();
				}

				TweenMax.to('[data-component="login"]', .8, { height: 450, ease: Sine.easeOut});
				TweenMax.to('[data-component="pass-monitor"] ' + this.activeAdvice, .8, {delay: data.delay, left: '50%', ease: Quint.easeOut});


			}

		}, 10);

	}

	hide() {
		TweenMax.to('[data-component="pass-monitor"] .advice', .8, { left: '320%', ease: Quint.easeOut});
		TweenMax.delayedCall(.6, () => {
			this.active = false;
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/autentication/pass-monitor/pass-monitor.component.ts